(function () {
'use strict';
/* ═══════════════════════════════════════════════════════════════════════════════
   De Leville · LILLO on a phone: the choice IS the ring.

   Eliau, 18 Sep 2026: "when you tap on changing the color on a phone you dont see the
   actual color changes, is just text… maybe we can bring things closer, condense."
   Then, 20 Sep: "i like b4 but make it more precise, just like my ring. (with the actual
   drawing of the logo)" and "I like more this style where you see the up and down."

   So, on a phone: every Style and every Metal is a circle of the band itself, drawn —
   two rails, the maison's mark between them, the next one upside down, and what that
   piece sets into it. The sticky bar carries the ring's own photograph, which follows
   every tap. Metal changes in place, like Style: no reload, your place and your
   choices stay. Desktop is untouched.
   ═══════════════════════════════════════════════════════════════════════════════ */
const PHONE = matchMedia('(max-width: 1024px)');
if (!document.querySelector('.dlb[data-dlb]')) return;          // LILLO pages only

const $ = (s, r) => (r || document).querySelector(s), $$ = (s, r) => [...(r || document).querySelectorAll(s)];
const root = document.documentElement;
root.classList.add('dlr');
const sized = (u, w) => !u ? u : /([?&])width=\d+/.test(u) ? u.replace(/([?&])width=\d+/, '$1width=' + w) : u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
const firstPhoto = () => $('[data-pdp-images] img.pdp-hero--main-image');
const swapped = fn => document.addEventListener('snc:pdp:swapped', () => setTimeout(fn, 0));
const pathOf = href => { try { return new URL(href, location.href).pathname; } catch (e) { return href; } };
const tierOf = href => (pathOf(href).match(/lillo-([a-z]+)-ring/) || [])[1] || '';
const goldOf = href => (pathOf(href).match(/ring-([a-z]+)-gold/) || [])[1] || '';
const dlT = function (k, f) { var d = window.DL_I18N; return (d && d[k] != null) ? d[k] : f; };
const NAME = { yellow: dlT('lillo.metal_yellow', 'Yellow'), rose: dlT('lillo.metal_rose', 'Rose'), white: dlT('lillo.metal_white', 'White') };

/* ── the maison's mark, measured off its own artwork ──────────────────────────
   `assets/Monogram_De_Leville.png` is the only master of the L-D monogram — there is
   no vector of it anywhere — so it was measured off that artwork: two strokes of one
   width, round ends, round corners. That covers 97.96% of its pixels; what is left is
   a hair at the outer corners. Kept here in the artwork's own coordinates, so every
   number stays checkable against the file it came from. */
const MONO = {
  w: 111.9,                                             // the stroke, in the artwork's pixels
  lines: [[[459.5, 58.4], [40.8, 971.7], [263.5, 1003.9]],        // the long stroke and its foot
          [[460.8, 751.2], [752, 57.2], [1182.5, 996.5], [504.1, 997]]], // inner stroke, apex, leg, base
  box: [-15.1, 1.3, 1253.6, 1058.6],                    // x, y, width, height, stroke included
  stone: [[754, 196], [1096, 941], [442, 941]],         // the triangle Segreto and Regale set
};
const MONO_D = MONO.lines.map(l => 'M' + l.map(p => p.join(' ')).join('L')).join('');
const PAVE = (() => {                                   // Essenza and Regale set every bar
  const step = MONO.w * 1.05, out = [];
  MONO.lines.forEach(line => {
    const seg = []; let total = 0;
    for (let i = 0; i < line.length - 1; i++) {
      seg.push(Math.hypot(line[i + 1][0] - line[i][0], line[i + 1][1] - line[i][1]));
      total += seg[i];
    }
    const run = total - MONO.w, n = Math.max(1, Math.round(run / step));
    for (let k = 0; k <= n; k++) {
      let t = MONO.w / 2 + run * k / n, i = 0;
      while (i < seg.length - 1 && t > seg[i]) { t -= seg[i]; i++; }
      const a = line[i], b = line[i + 1], f = t / seg[i];
      out.push([a[0] + (b[0] - a[0]) * f, a[1] + (b[1] - a[1]) * f]);
    }
  });
  return out;
})();
/* ── the metals, measured off the renders ─────────────────────────────────────
   Eliau, 20 Sep: "the gold is a bit too dark… make it brighter… the white one, give
   me a few other options. Needs to be more well-thought-out."

   One formula tinted three ways was the mistake: rose and yellow carry their colour,
   white gold carries almost none, so grey-by-recipe reads as concrete. So each metal
   is measured on its own piece — a box entirely inside the band face on the VISTA TOP
   render of LILLO Puro, in all three golds — and the drawing is built from what the
   metal actually does: the shadow it casts through the openwork, the face it turns to
   the light, and the catch on the rail. */
const METAL = {
  rose:   { lo: '#6f3b25', body: '#f2c4b0', hi: '#f9eae4' },
  yellow: { lo: '#5d3e06', body: '#dfc890', hi: '#f8efd1' },
  white:  { lo: '#494949', body: '#d0d0d0', hi: '#efefef' },
};
const rgb = h => [1, 3, 5].map(i => parseInt(h.substr(i, 2), 16));
const mix = (a, b, k) => { const A = rgb(a), B = rgb(b);
  return '#' + A.map((v, i) => Math.round(v + (B[i] - v) * k).toString(16).padStart(2, '0')).join(''); };

/* The band drawn on white, in the metal's own colour. Eliau, 20 Sep: "I want the background of
   it to be white and the actual ring on the four pills of styles to be of the color of the ring."
   The relief light stays — a hairline of light along the upper edge of every bar, of shadow along
   the lower — so the metal has a body on the white; the openwork is the page showing through, with
   the faintest shadow so the band still reads as a band. The three treatments that lost on 20 Sep
   (metal, air, raking) are in commit a34cef7. */
const WHITE = '#ffffff';
let uid = 0;
function mark(tier, gold) {
  const m = METAL[gold] || METAL.rose;
  const RAIL = 3, TOP = 13, BOT = 35;                   // the band, across a 48-wide circle
  const top = TOP + RAIL / 2, bot = BOT - RAIL / 2;
  const s = (bot - top) / MONO.box[3], w = MONO.box[2] * s, pitch = w * 1.02;
  const sw = MONO.w * 1.2;                              // the measured stroke, opened up for 62 px
  const id = 'dlrm' + (++uid), metal = 'url(#' + id + ')';
  /* The openwork is 23% of the real band and about half of a drawing at this size, so a shadow at
     full strength reads twice as heavy as the piece does. On white it is barely there at all. */
  const cavity = mix(WHITE, m.lo, .07), setting = mix(m.body, m.lo, .45);

  const c = MONO.stone.reduce((a, p) => [a[0] + p[0] / 3, a[1] + p[1] / 3], [0, 0]);
  const pts = f => MONO.stone.map(p => [c[0] + (p[0] - c[0]) * f, c[1] + (p[1] - c[1]) * f]);
  const tri = f => 'M' + pts(f).map(p => p[0].toFixed(0) + ' ' + p[1].toFixed(0)).join('L') + 'Z';
  const facets = () => pts(.95).map((p, i) => {         // corner to table: a trillion's own cut
    const q = pts(.42)[i];
    return 'M' + p[0].toFixed(0) + ' ' + p[1].toFixed(0) + 'L' + q[0].toFixed(0) + ' ' + q[1].toFixed(0);
  }).join('');
  const bars = paint => '<path d="' + MONO_D + '" fill="none" stroke="' + paint + '" stroke-width="'
    + sw.toFixed(0) + '" stroke-linecap="round" stroke-linejoin="round"/>';
  const stones = ''
    + (/essenza|regale/.test(tier) ? PAVE.map(p => '<circle cx="' + p[0].toFixed(0) + '" cy="'
        + p[1].toFixed(0) + '" r="' + (MONO.w * .48).toFixed(0) + '" fill="#fff" stroke="' + setting
        + '" stroke-width="12" stroke-opacity=".5"/>').join('') : '')
    + (/segreto|regale/.test(tier) ? '<path d="' + tri(.95) + '" fill="#fff" stroke="' + setting
        + '" stroke-width="30" stroke-linejoin="round"/><path d="' + tri(.42) + facets()
        + '" fill="none" stroke="' + setting + '" stroke-width="20" stroke-opacity=".55" stroke-linejoin="round"/>' : '');
  /* a hairline of light on the upper edge of every bar, of shadow on the lower: a stamped mark */
  const piece = '<g transform="translate(0 -26)">' + bars(m.hi) + '</g>'
    + '<g transform="translate(0 30)">' + bars(mix(m.body, m.lo, .38)) + '</g>'
    + bars(m.body) + stones;
  const at = (cx, up) => '<g transform="translate(' + (cx + (up ? -w / 2 : w / 2)).toFixed(2) + ' '
    + (up ? top : bot).toFixed(1) + ') scale(' + (up ? s : -s).toFixed(5) + ') translate('
    + -MONO.box[0] + ' ' + -MONO.box[1] + ')">' + piece + '</g>';
  /* one the right way up, the next one upside down, the way the band alternates them */
  const band = [-1.5, -0.5, .5, 1.5].map((k, i) => at(24 + k * pitch, i % 2 === 1)).join('');
  const rail = y => '<rect x="-6" y="' + y + '" width="60" height="' + RAIL + '" fill="' + metal + '"/>';
  return '<svg viewBox="0 0 48 48" aria-hidden="true"><defs>'
    + '<linearGradient id="' + id + '" x1="0" y1="' + (TOP - RAIL / 2) + '" x2="0" y2="' + (BOT + RAIL / 2) + '" gradientUnits="userSpaceOnUse">'
    + '<stop offset="0" stop-color="' + m.hi + '"/><stop offset=".42" stop-color="' + m.body
    + '"/><stop offset="1" stop-color="' + mix(m.body, m.lo, .14) + '"/></linearGradient>'
    + '</defs>'
    + '<rect x="-6" y="-6" width="60" height="60" fill="' + WHITE + '"/>'
    + '<rect x="-6" y="' + top.toFixed(1) + '" width="60" height="' + (bot - top).toFixed(1) + '" fill="' + cavity + '"/>'
    + band + rail(TOP - RAIL / 2) + rail(BOT - RAIL / 2) + '</svg>';
}

/* ── Metal in place, like Style: the theme's own in-place switch, reached through a Style link ── */
addEventListener('click', e => {
  if (!PHONE.matches) return;
  const sw = e.target.closest && e.target.closest('.pdp-variant-selector__swatch');
  if (!sw || sw.classList.contains('is-active')) return;
  e.preventDefault(); e.stopPropagation();
  const a = document.createElement('a');
  a.className = 'pdp-variant-selector__pill'; a.hidden = true;
  a.setAttribute('href', pathOf(sw.getAttribute('href')));
  document.body.appendChild(a); a.click(); a.remove();
}, true);

/* ── the Add to Bag bar waits until the choosing is done ──────────────────────
   Eliau, 22 Sep, on a tablet: "I can't select the style and the color because the picture
   is blocked by the line at the top… the Add to Bag should appear only after the product
   information. This is just for phone and for iPad or fold phones."

   The theme shows the bar once you are 80px past the in-page Add to Bag button — but that
   button is hidden at these widths, so its recorded offset is meaningless and the bar came
   up over the picture almost at once. Here it holds until the engraving block has gone by,
   which is the last thing a buyer chooses. Desktop keeps the theme's own behaviour. */
function gateBar() {                                    // never latches: it decides both ways, every time
  const en = $('[data-dlb-en]');
  const past = !PHONE.matches || !en || en.getBoundingClientRect().bottom < 40;
  root.classList.toggle('dlr-cta', past);
}
addEventListener('scroll', gateBar, { passive: true });
addEventListener('resize', gateBar);
addEventListener('load', gateBar);                      // a deferred script can run before the viewport settles
if (PHONE.addEventListener) PHONE.addEventListener('change', gateBar); else PHONE.addListener(gateBar);

/* ── the ring's own photograph in the sticky bar, following every tap ────────── */
const thumb = $('.pdp-sticky-bar--thumb');
if (thumb && !thumb.parentNode.classList.contains('dlr-thumb')) {   // a clipping box, so the ring can fill it
  const box = document.createElement('span'); box.className = 'dlr-thumb';
  thumb.replaceWith(box); box.appendChild(thumb);
}
function syncThumb() {
  const f = firstPhoto(), src = f && sized(f.getAttribute('src'), 240);
  if (!thumb || !src || thumb.getAttribute('src') === src) return;
  thumb.classList.add('is-fading');
  const n = new Image();                                  // load first, then swap, so it never flashes empty
  n.onload = n.onerror = () => { thumb.src = src; thumb.classList.remove('is-fading'); };
  n.src = src;
}

/* ── the circles ──────────────────────────────────────────────────────────────
   Style gets the band, drawn. Metal keeps the theme's own three discs of metal —
   Eliau, 20 Sep: "the metal colors should still be the 3 circle of colors (it's too
   repetitive to have again the ring)" — only larger, with the gold's name under it. */
function tiles() {
  $$('.pdp-variant-selector__pill').forEach(a => {
    if (a.querySelector('.dlr-dot')) return;
    const dot = document.createElement('span'); dot.className = 'dlr-dot';
    dot.innerHTML = mark(tierOf(a.getAttribute('href')), goldOf(location.pathname));
    a.prepend(dot);
  });
  $$('.pdp-variant-selector__swatch').forEach(a => {
    if (a.querySelector('.dlr-name')) return;
    const n = document.createElement('span'); n.className = 'dlr-name';
    n.textContent = NAME[goldOf(a.getAttribute('href'))] || (a.getAttribute('aria-label') || '').replace(/\s*gold$/i, '');
    a.appendChild(n);
  });
}
tiles(); syncThumb(); gateBar();
swapped(() => { tiles(); syncThumb(); gateBar(); });
})();
